const setHeightItem = {
    init(chefis) {
        window.addEventListener('load', () => {
            let maxItemHeight = 0;
            const chiefItem = chefis.querySelectorAll('.chiefs__item');
            chiefItem.forEach(chief => {
                const chiefsText = chief.querySelector('p');
                const itemHeight = chiefsText.scrollHeight + chief.scrollHeight;

                if (itemHeight > maxItemHeight) {
                    maxItemHeight = itemHeight;
                }
            });
            chefis.style.height = `${maxItemHeight}px`;
        });
    },
};
UX.setHeightItem = setHeightItem;
